import { get } from '../tools/http';
import { getImgUrl } from '../tools/uploader';

export default {
    namespaced: true,

    state: () => ({
        filters: [],
        tests: [],
        test: {},
        limit: 5,
        count: 1,
    }),

    mutations: {
        writeFilters: (state, filters) => state.filters = filters,
        writeTests: (state, tests) => state.tests = tests,
        writeTest: (state, test) => state.test = test,
        writeCount: (state, count) => state.count = count,
    },

    actions: {
        loadFilters: async (ctx) => {
            let res = await get('cms', 'entity/select/testCategory?limit=1000&offset=0');
            if (res) {
                ctx.commit('writeFilters', res.list);
            }
        },
        loadItems: async (ctx, {
            page,
            categoryId,
            limit = ctx.state.limit,
            offset =  ctx.state.limit * (page - 1),
        }) => {
            ctx.commit('writeTests', []);
            // const limit = ctx.state.limit;
            // const offset = limit * (page - 1);
            let res;
            if(categoryId == 'all') {
                res = await get(
                    'cms',
                    `entity/select/test?limit=${limit}&offset=${offset}`
                );
            } else {
                res = await get(
                    'cms',
                    `entity/select/test?limit=${limit}&offset=${offset}&categoryId=${categoryId}`
                );
            }

            if (res) {
                let preRender = await Promise.all(res.list.map(async t => {
                    t.preview = await getImgUrl(
                        t.preview,
                        ctx.rootGetters.img_stub
                    );
                    return t;
                }));
                ctx.commit('writeTests', preRender);
                ctx.commit('writeCount', res.count);
            }
        },
        loadItemById: async (ctx, id) => {
            ctx.commit('writeTest', {});
            let res = await get('cms', `entity/select/test?id=${id}`);
            if (res.list) {
                let preRender = res.list[0];
                preRender.preview = await getImgUrl(
                    preRender.preview,
                    ctx.rootGetters.img_stub
                );
                ctx.commit('writeTest', preRender);
            }
        },
    },

    getters: {
        getFilters: state => state.filters,
        getFilterById: state => id => state.filters.find(f => f.id == id) || {},
        getTests: state => state.tests,
        getCurrentTest: state => state.test,
        getCountOfPages: state => Math.ceil(state.count/state.limit),
    },
};

const get2 = (dom, path, params='') => {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(bd[path](params));
        }, 1000);
    });
};

const bd = {
    categories: () => {
        return Array.apply(null, Array(15)).map((item, index)=>({
            id: index + 1,
            name: 'Категория' + (index + 1),
            testsCount: (index + 1) * 3,
        }));
    },
    items: () => {
        return Array.apply(null, Array(6)).map((item, index)=>({
            id: Math.random().toString(36).substr(2, 9),
            name: 'Тест на крокодила Машу Соколову ' + (index + 1),
            questionsCount: (index + 1) * 3,
            foreignTestId : (index + 1) * 3,
            preview: 'https://i.pinimg.com/236x/b7/b8/96/b7b8961adbeb1dcdbe1570bdc8b508b7.jpg',
        }));
    },
    item: (id) => {
        return {
            id: id,
            name: `Тест на крокодила Машу Соколову ${id}`,
            questionsCount: (1) * 3,
            foreignTestId : (1) * 3,
            description: 'Экзаменационные материалы в виде набора контрольных заданий для проведения письменного экзамена по русскому языку по результатам освоения образовательной программы среднего (полного) общего образования, реализуемой в пределах основной профессиональной программы БПОУ «САПТ» составлены на основе федерального компонента государственных стандартов основного общего и среднего (полного) общего образования по русскому языку базового уровня (Приказ Минобразования России от 05.03.2004 г. № 1089 «Об утверждении федерального компонента государственных образовательных стандартов начального общего. основного общего и среднего (полного) общего образования».',
            preview: 'https://i.pinimg.com/236x/b7/b8/96/b7b8961adbeb1dcdbe1570bdc8b508b7.jpg',
        };
    },

};